import React from 'react';
import clsx from 'clsx';
import iconStyles from '@danske/sapphire-css/components/icon/icon.module.css';
import styles from '@danske/sapphire-css/components/listbox/listbox.module.css';
import { Skeleton } from '../../Skeleton';

interface ListBoxItemSkeletonProps {
  index?: number;
  /**
   * Can be used for rendering custom skeleton (ReactNode) instead of primaryText
   * @default 'true'
   */
  primaryText?: boolean | React.ReactNode;
  secondaryText?: boolean | React.ReactNode;
  icon?: boolean | React.ReactNode;
  /**
   * The size of the skeleton icon.
   * @default 'lg'
   */
  iconSize?: 'sm' | 'md' | 'lg' | 'xl';
}

export const ListBoxItemSkeleton: React.FC<ListBoxItemSkeletonProps> = ({
  index,
  primaryText = true,
  secondaryText = false,
  icon = false,
  iconSize = 'lg',
}) => (
  <div
    className={clsx(
      styles['sapphire-listbox__item'],
      styles['js-hover'],
      styles['js-focus']
    )}
  >
    <div className={styles['sapphire-listbox__content']}>
      {icon && (
        <div className={styles['sapphire-listbox__icon']}>
          <div
            className={clsx(iconStyles['sapphire-icon'], {
              [iconStyles['sapphire-icon--sm']]: iconSize === 'sm',
              [iconStyles['sapphire-icon--md']]: iconSize === 'md',
              [iconStyles['sapphire-icon--lg']]: iconSize === 'lg',
              [iconStyles['sapphire-icon--xl']]: iconSize === 'xl',
            })}
          >
            {icon === true ? <Skeleton.Circle index={index} /> : icon}
          </div>
        </div>
      )}
      <div className={styles['sapphire-listbox__text-container']}>
        <div className={styles['sapphire-listbox__primary-text']}>
          {primaryText === true ? <Skeleton.Text index={index} /> : primaryText}
        </div>
        {secondaryText && (
          <div className={styles['sapphire-listbox__secondary-text']}>
            {secondaryText === true ? (
              <Skeleton.Text index={index} />
            ) : (
              secondaryText
            )}
          </div>
        )}
      </div>
    </div>
  </div>
);
